import { CaptionDto } from "@repo/api/caption";
import { Button } from "@/lib/components/Button/Button";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { useDeleteCustomCaptionMutation } from "@/lib/queries/caption-queries";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/lib/components/Dialog";
import Toast from "@/lib/components/Toast";

type DeletePresetDialogProps = {
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
  selectedPreset: CaptionDto;
  teamExternalId: string;
  onDeleted: () => void;
};

function DeletePresetDialog({
  open,
  onOpenChange,
  selectedPreset,
  teamExternalId,
  onDeleted,
}: DeletePresetDialogProps) {
  const updateVideo = useEditorStore((state) => state.service.updateVideo);

  const deleteCustomCaption = useDeleteCustomCaptionMutation({
    teamExternalId,
    onSuccess: () => {
      Toast.info("Preset deleted successfully");

      updateVideo((video) => {
        video.compositionJson.captions = undefined;
      });

      onOpenChange(false);
      onDeleted();
    },
  });

  const isDeleting = deleteCustomCaption.isPending;

  const handleDelete = () => {
    if (isDeleting) return;
    deleteCustomCaption.mutate(selectedPreset.externalId);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader className="w-full">
          <DialogTitle>Delete Preset</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the preset
            {selectedPreset.name && (
              <>
                {" "}
                <span className="font-semibold">{selectedPreset.name}</span>
              </>
            )}
            ?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-0">
          <Button onClick={handleDelete} disabled={isDeleting}>
            Delete
          </Button>
          <DialogClose asChild>
            <Button type="button" variant="outline" disabled={isDeleting}>
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DeletePresetDialog;
